const INITIAL_TIME = 50;

const FRAME_RATE = 20;

export {
    INITIAL_TIME,
    FRAME_RATE
};